import { call, put, takeLatest } from "redux-saga/effects";
import { Endpoints } from "services/api";
import errorHandler from "common/errorHandler";
import * as actions from "./actions";

// No tenantid header — the tenant is determined server-side from the auth-token claims.

export function* getStewardConflictsRequest(api, action) {
    try {
        const { duplicateSetId, duplicateSetVersion, groupId } = action.params;
        const result = yield call(
            [api, api.get],
            `${Endpoints.duplicates}/api/v1/dataobjects/nominate/survivor/set/${duplicateSetId}/group/${groupId}/version/${duplicateSetVersion}/preview`,
        );
        yield put(actions.getStewardConflictsSuccess((result.data && result.data.fieldConflicts) || []));
    } catch (error) {
        yield put(actions.getStewardConflictsFailure(errorHandler(error, "Get", "steward review conflicts")));
    }
}

export function* stewardResolveRequest(api, action) {
    try {
        const result = yield call([api, api.post], `${Endpoints.duplicates}/api/v1/dataobjects/steward/resolve`, action.params);
        yield put(actions.stewardResolveSuccess(result.data));
    } catch (error) {
        yield put(actions.stewardResolveFailure(errorHandler(error, "Resolve", "steward review")));
    }
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_STEWARD_CONFLICTS_REQUEST, getStewardConflictsRequest, api);
    yield takeLatest(actions.STEWARD_RESOLVE_REQUEST, stewardResolveRequest, api);
}
